var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm work-card",
                  attrs: { title: "기준정보", noMarginPadding: true },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editable && !_vm.disabled,
                                expression: "editable && !disabled",
                              },
                            ],
                            attrs: { label: "업체 내용 전달", icon: "send" },
                            on: { btnClicked: _vm.vendorSendDialogOpen },
                          }),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editable && !_vm.disabled,
                                expression: "editable && !disabled",
                              },
                            ],
                            attrs: {
                              isSubmit: _vm.isSave,
                              url: _vm.saveUrl,
                              param: _vm.workPermit,
                              mappingType: _vm.mappingType,
                              label: _vm.saveBtnLabel,
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveWorkPermit,
                              btnCallback: _vm.saveWorkPermitCallback,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "card-detail" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-4 col-md-2 col-lg-2 work-item",
                        },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: true,
                              disabled: !_vm.isWriting,
                              editable: _vm.editable,
                              label: "사업장",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.workPermit.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.workPermit, "plantCd", $$v)
                              },
                              expression: "workPermit.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-4 col-md-2 col-lg-2 work-item",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              disabled: true,
                              editable: _vm.editable,
                              label: "허가번호",
                              name: "permitNo",
                            },
                            model: {
                              value: _vm.workPermit.permitNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.workPermit, "permitNo", $$v)
                              },
                              expression: "workPermit.permitNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-2 col-md-1 col-lg-1 work-item",
                        },
                        [
                          _c("c-checkbox", {
                            attrs: {
                              disabled: !_vm.isWriting,
                              editable: _vm.editable,
                              isFlag: true,
                              label: "기간 여부",
                              name: "periodFlag",
                            },
                            on: { datachange: _vm.changePeriodFlag },
                            model: {
                              value: _vm.workPermit.periodFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.workPermit, "periodFlag", $$v)
                              },
                              expression: "workPermit.periodFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.workPermit.periodFlag === "Y"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-6 col-md-3 col-lg-3 work-item",
                            },
                            [
                              _c("c-datepicker", {
                                attrs: {
                                  required: true,
                                  disabled: !_vm.isWriting,
                                  editable: _vm.editable,
                                  range: true,
                                  minuteStep: 10,
                                  type: "datetime",
                                  label: "허가작업일정",
                                  name: "permitPeriod",
                                },
                                model: {
                                  value: _vm.workPermit.permitPeriod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.workPermit,
                                      "permitPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "workPermit.permitPeriod",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.workPermit.periodFlag === "N"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-2 col-md-1 col-lg-1 work-item",
                            },
                            [
                              _c("c-datepicker", {
                                attrs: {
                                  required: true,
                                  disabled: !_vm.isWriting,
                                  editable: _vm.editable,
                                  label: "허가작업일",
                                  name: "permitDate",
                                },
                                model: {
                                  value: _vm.workPermit.permitDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.workPermit, "permitDate", $$v)
                                  },
                                  expression: "workPermit.permitDate",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.workPermit.periodFlag === "N"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-4 col-md-2 col-lg-2 work-item",
                            },
                            [
                              _c("c-datepicker", {
                                attrs: {
                                  required: true,
                                  disabled: !_vm.isWriting,
                                  editable: _vm.editable,
                                  range: true,
                                  minuteStep: 10,
                                  type: "time",
                                  label: "작업시간",
                                  name: "workTime",
                                },
                                model: {
                                  value: _vm.workPermit.workTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.workPermit, "workTime", $$v)
                                  },
                                  expression: "workPermit.workTime",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 work-item",
                        },
                        [
                          _c("c-multi-select", {
                            attrs: {
                              disabled: !_vm.isWriting,
                              editable: _vm.editable,
                              codeGroupCd: "SOP_SUPPLEMENT_WORK_TYPE_CD",
                              itemText: "codeName",
                              itemValue: "code",
                              label: "보충작업",
                              name: "supWorks",
                            },
                            on: { datachange: _vm.changeSupWork },
                            model: {
                              value: _vm.supWorks,
                              callback: function ($$v) {
                                _vm.supWorks = $$v
                              },
                              expression: "supWorks",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.isWorkInfo
                        ? [
                            _c("q-slide-transition", [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.visible,
                                      expression: "visible",
                                    },
                                  ],
                                  staticClass: "row",
                                  staticStyle: {
                                    display: "-webkit-inline-box",
                                    width: "100%",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-12 col-sm-6 col-md-3 col-lg-3",
                                    },
                                    [
                                      _c(
                                        "q-card",
                                        {
                                          staticClass: "work-card",
                                          class: _vm.cancelFlag
                                            ? "bg-highLight"
                                            : "",
                                          attrs: { flat: "", bordered: "" },
                                        },
                                        [
                                          _c(
                                            "q-card-section",
                                            {
                                              staticClass:
                                                "q-pa-xs q-pl-sm bg-grey-3",
                                              class:
                                                this.editable &&
                                                !this.disabled &&
                                                !this.disableCancel
                                                  ? "cursor-pointer"
                                                  : "cursor-not-allowed",
                                              on: {
                                                click: _vm.qCardCancelClick,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-orange-9 work-title-text",
                                                },
                                                [
                                                  _c("q-checkbox", {
                                                    attrs: {
                                                      size: "22px",
                                                      label: "",
                                                      disable:
                                                        _vm.disableCancel ||
                                                        _vm.disabled ||
                                                        !_vm.editable,
                                                    },
                                                    on: {
                                                      input: _vm.changeCancel,
                                                    },
                                                    model: {
                                                      value: _vm.cancelFlag,
                                                      callback: function ($$v) {
                                                        _vm.cancelFlag = $$v
                                                      },
                                                      expression: "cancelFlag",
                                                    },
                                                  }),
                                                  _vm._v(" 취소 "),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c("q-separator"),
                                          _c(
                                            "q-card-section",
                                            { staticClass: "no-padding row" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-12 work-item",
                                                },
                                                [
                                                  _c("c-textarea", {
                                                    attrs: {
                                                      required: _vm.cancelFlag,
                                                      editable: _vm.editable,
                                                      disabled:
                                                        _vm.disabled ||
                                                        !_vm.cancelFlag,
                                                      rows: 3,
                                                      label: "취소사유",
                                                      beforeText: "",
                                                      name: "cancelRemark",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.workPermit
                                                          .cancelRemark,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.workPermit,
                                                          "cancelRemark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "workPermit.cancelRemark",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-12 col-sm-6 col-md-3 col-lg-3",
                                    },
                                    [
                                      _c(
                                        "q-card",
                                        {
                                          staticClass: "work-card",
                                          class: _vm.overFlag
                                            ? "bg-highLight"
                                            : "",
                                          attrs: { flat: "", bordered: "" },
                                        },
                                        [
                                          _c(
                                            "q-card-section",
                                            {
                                              staticClass:
                                                "q-pa-xs q-pl-sm cursor-pointer bg-grey-3",
                                              staticStyle: {
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "absolute",
                                                    right: "10px",
                                                    top: "3px",
                                                    "z-index": "10600",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "q-btn-group",
                                                    { attrs: { outline: "" } },
                                                    [
                                                      _vm.editable &&
                                                      _vm.overFlag &&
                                                      !_vm.disabled
                                                        ? _c("c-btn", {
                                                            attrs: {
                                                              label: "추가",
                                                              icon: "add",
                                                              showLoading: false,
                                                            },
                                                            on: {
                                                              btnClicked:
                                                                _vm.addOver,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm.editable &&
                                                      _vm.overFlag &&
                                                      !_vm.disabled
                                                        ? _c("c-btn", {
                                                            attrs: {
                                                              label: "제외",
                                                              icon: "remove",
                                                              showLoading: false,
                                                            },
                                                            on: {
                                                              btnClicked:
                                                                _vm.removeOver,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "q-card-section",
                                            {
                                              staticClass:
                                                "q-pa-xs q-pl-sm bg-grey-3",
                                              class:
                                                this.editable && !this.disabled
                                                  ? "cursor-pointer"
                                                  : "cursor-not-allowed",
                                              staticStyle: {
                                                "min-height": "23px",
                                              },
                                              on: { click: _vm.qCardOverClick },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-orange-9 work-title-text float-left",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    top: "-3px",
                                                  },
                                                },
                                                [
                                                  _c("q-checkbox", {
                                                    attrs: {
                                                      size: "22px",
                                                      label: "",
                                                      disable: _vm.disabled,
                                                    },
                                                    on: {
                                                      input: _vm.changeOver,
                                                    },
                                                    model: {
                                                      value: _vm.overFlag,
                                                      callback: function ($$v) {
                                                        _vm.overFlag = $$v
                                                      },
                                                      expression: "overFlag",
                                                    },
                                                  }),
                                                  _vm._v(" 연장 "),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c("q-separator"),
                                          _c(
                                            "q-card-section",
                                            {
                                              staticClass: "no-padding row",
                                              staticStyle: { width: "100%" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-12" },
                                                [
                                                  _c("c-table", {
                                                    ref: "tableOver",
                                                    staticClass:
                                                      "work-permit-table",
                                                    attrs: {
                                                      title: "",
                                                      tableId: "01",
                                                      columns: _vm.grid.columns,
                                                      data: _vm.workPermit
                                                        .overs,
                                                      gridHeight:
                                                        _vm.grid.height,
                                                      editable:
                                                        _vm.editable &&
                                                        _vm.overFlag &&
                                                        !_vm.disabled,
                                                      tableTimePickerOptions:
                                                        _vm.tableTimePickerOptions,
                                                      filtering: false,
                                                      columnSetting: false,
                                                      usePaging: false,
                                                      isTitle: false,
                                                      hideHeader: false,
                                                      hideBottom: true,
                                                      noHighLight: true,
                                                      noHoverRow: true,
                                                      selection: "multiple",
                                                      rowKey: "sopOverResultId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 grid-style-transition",
                                    },
                                    [
                                      _c(
                                        "q-card",
                                        {
                                          staticClass: "work-card",
                                          class: _vm.completeFlag
                                            ? "bg-highLight"
                                            : "",
                                          attrs: { flat: "", bordered: "" },
                                        },
                                        [
                                          _c(
                                            "q-card-section",
                                            {
                                              staticClass:
                                                "q-pa-xs q-pl-sm bg-grey-3",
                                              class:
                                                this.editable &&
                                                !this.disabled &&
                                                !this.disableComplete
                                                  ? "cursor-pointer"
                                                  : "cursor-not-allowed",
                                              on: {
                                                click: _vm.qCardCompleteClick,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-orange-9 work-title-text",
                                                },
                                                [
                                                  _c("q-checkbox", {
                                                    attrs: {
                                                      size: "22px",
                                                      label: "",
                                                      disable:
                                                        _vm.disableComplete ||
                                                        _vm.disabled,
                                                    },
                                                    on: {
                                                      input: _vm.changeComplete,
                                                    },
                                                    model: {
                                                      value: _vm.completeFlag,
                                                      callback: function ($$v) {
                                                        _vm.completeFlag = $$v
                                                      },
                                                      expression:
                                                        "completeFlag",
                                                    },
                                                  }),
                                                  _vm._v(" 완료 "),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c("q-separator"),
                                          _c(
                                            "q-card-section",
                                            { staticClass: "no-padding row" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-4 work-item",
                                                },
                                                [
                                                  _c("c-datepicker", {
                                                    attrs: {
                                                      required:
                                                        _vm.completeFlag,
                                                      editable: _vm.editable,
                                                      disabled:
                                                        _vm.disabled ||
                                                        !_vm.completeFlag,
                                                      minuteStep: 10,
                                                      type: "time",
                                                      label: "완료시간",
                                                      beforeText: "",
                                                      name: "workCompleteTime",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.workPermit
                                                          .workCompleteTime,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.workPermit,
                                                          "workCompleteTime",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "workPermit.workCompleteTime",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-4 work-item",
                                                },
                                                [
                                                  _c("c-field", {
                                                    attrs: {
                                                      required:
                                                        _vm.completeFlag,
                                                      editable: _vm.editable,
                                                      disabled:
                                                        _vm.disabled ||
                                                        !_vm.completeFlag,
                                                      data: _vm.workPermit,
                                                      deptValue:
                                                        "workCompleteEntryDeptCd",
                                                      type: "dept_user",
                                                      label: "확인자",
                                                      beforeText: "",
                                                      name: "workCompleteEntryUserId",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.workPermit
                                                          .workCompleteEntryUserId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.workPermit,
                                                          "workCompleteEntryUserId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "workPermit.workCompleteEntryUserId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-4 work-item",
                                                },
                                                [
                                                  _c("c-field", {
                                                    attrs: {
                                                      required:
                                                        _vm.completeFlag,
                                                      editable: _vm.editable,
                                                      disabled:
                                                        _vm.disabled ||
                                                        !_vm.completeFlag,
                                                      data: _vm.workPermit,
                                                      deptValue:
                                                        "workCompleteWorkDeptCd",
                                                      type: "dept_user",
                                                      label: "작업자",
                                                      beforeText: "",
                                                      name: "workCompleteWorkUserId",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.workPermit
                                                          .workCompleteWorkUserId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.workPermit,
                                                          "workCompleteWorkUserId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "workPermit.workCompleteWorkUserId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-12 work-item",
                                                },
                                                [
                                                  _c("c-text", {
                                                    attrs: {
                                                      editable: _vm.editable,
                                                      disabled:
                                                        _vm.disabled ||
                                                        !_vm.completeFlag,
                                                      label: "조치사항",
                                                      beforeText: "",
                                                      name: "actionRemark",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.workPermit
                                                          .actionRemark,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.workPermit,
                                                          "actionRemark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "workPermit.actionRemark",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-12 folder-area" },
                              [
                                _c("q-btn", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    size: "2px",
                                    color: "light-blue",
                                    icon: _vm.folderIcon,
                                  },
                                  on: { click: _vm.folder },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("c-tab", {
        staticClass: "q-mt-sm",
        attrs: {
          type: "tabcard",
          align: "left",
          tabItems: _vm.tabItems,
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.componentKey,
                  ref: "swp-tab",
                  tag: "component",
                  attrs: {
                    workPermit: _vm.workPermit,
                    supWork: tab.supWork,
                    isApprUser: _vm.isApprUser,
                    checkResultEditable: _vm.checkResultEditable,
                    gasEditable: _vm.gasEditable,
                    disabled: _vm.disabled,
                    isOld: _vm.isOld,
                    isWriting: _vm.isWriting,
                    saveAction: _vm.saveAction,
                    height: _vm.tabHeight,
                  },
                  on: {
                    "update:workPermit": function ($event) {
                      _vm.workPermit = $event
                    },
                    "update:work-permit": function ($event) {
                      _vm.workPermit = $event
                    },
                    "update:supWork": function ($event) {
                      return _vm.$set(tab, "supWork", $event)
                    },
                    "update:sup-work": function ($event) {
                      return _vm.$set(tab, "supWork", $event)
                    },
                    "update:isApprUser": function ($event) {
                      _vm.isApprUser = $event
                    },
                    "update:is-appr-user": function ($event) {
                      _vm.isApprUser = $event
                    },
                    "update:checkResultEditable": function ($event) {
                      _vm.checkResultEditable = $event
                    },
                    "update:check-result-editable": function ($event) {
                      _vm.checkResultEditable = $event
                    },
                    "update:gasEditable": function ($event) {
                      _vm.gasEditable = $event
                    },
                    "update:gas-editable": function ($event) {
                      _vm.gasEditable = $event
                    },
                    "update:disabled": function ($event) {
                      _vm.disabled = $event
                    },
                    validResult: _vm.validResult,
                  },
                }),
              ]
            },
          },
          {
            key: "customTab",
            fn: function () {
              return [
                _c("q-tab", {
                  attrs: {
                    name: "references",
                    icon: "description",
                    label: "관련정보",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "customTabPanel",
            fn: function () {
              return [
                _c(
                  "q-tab-panel",
                  { attrs: { name: "references" } },
                  [
                    _c(
                      "keep-alive",
                      [
                        _c(_vm.referencesCompo, {
                          key: _vm.referencesKey,
                          tag: "component",
                          attrs: {
                            workPermit: _vm.workPermit,
                            supWorks: _vm.supWorks,
                            saveCall: _vm.saveCall,
                            isWriting: _vm.isWriting,
                            height: _vm.tabHeight,
                          },
                          on: {
                            "update:workPermit": function ($event) {
                              _vm.workPermit = $event
                            },
                            "update:work-permit": function ($event) {
                              _vm.workPermit = $event
                            },
                            "update:supWorks": function ($event) {
                              _vm.supWorks = $event
                            },
                            "update:sup-works": function ($event) {
                              _vm.supWorks = $event
                            },
                            "update:saveCall": function ($event) {
                              _vm.saveCall = $event
                            },
                            "update:save-call": function ($event) {
                              _vm.saveCall = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
      _c(
        "q-dialog",
        {
          attrs: { persistent: "" },
          model: {
            value: _vm.vendorSendDialog.show,
            callback: function ($$v) {
              _vm.$set(_vm.vendorSendDialog, "show", $$v)
            },
            expression: "vendorSendDialog.show",
          },
        },
        [
          _c(
            "q-card",
            { staticStyle: { "min-width": "450px" } },
            [
              _c(
                "q-form",
                { ref: "editForm2" },
                [
                  _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm",
                      attrs: { title: "전달 내용" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "card-button" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.editable && !_vm.disabled,
                                    expression: "editable && !disabled",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isVendorSend,
                                  url: _vm.saveUrl,
                                  param: _vm.workPermit,
                                  mappingType: "PUT",
                                  label: "전달",
                                  icon: "send",
                                  color: "blue-7",
                                },
                                on: {
                                  beforeAction: _vm.vendorSendWorkPermit,
                                  btnCallback: _vm.vendorSendWorkPermitCallback,
                                },
                              }),
                              _c("c-btn", {
                                attrs: { label: "닫기", icon: "cancel" },
                                on: { btnClicked: _vm.closeVendorSendDialog },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-textarea", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: _vm.disabled,
                                rows: 5,
                                label: "",
                                name: "vendorComment",
                              },
                              model: {
                                value: _vm.workPermit.vendorComment,
                                callback: function ($$v) {
                                  _vm.$set(_vm.workPermit, "vendorComment", $$v)
                                },
                                expression: "workPermit.vendorComment",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }